"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1, 0),
      minWidth: 120
    }
  };
});

var TsTextField = function TsTextField(_ref) {
  var _ref$handleChange = _ref.handleChange,
      handleChange = _ref$handleChange === void 0 ? function () {} : _ref$handleChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$startAdornment = _ref.startAdornment,
      startAdornment = _ref$startAdornment === void 0 ? null : _ref$startAdornment,
      _ref$endAdornment = _ref.endAdornment,
      endAdornment = _ref$endAdornment === void 0 ? null : _ref$endAdornment,
      multiline = _ref.multiline,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 1 : _ref$rows,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputLabelProps = _ref.inputLabelProps,
      inputProps = _ref.inputProps;
  var classes = useStyles();

  var inputLabel = _react.default.useRef(null);

  var _React$useState = _react.default.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      labelWidth = _React$useState2[0],
      setLabelWidth = _React$useState2[1];

  _react.default.useEffect(function () {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return _react.default.createElement(_core.FormControl, {
    variant: "outlined",
    className: classes.formControl,
    fullWidth: fullWidth,
    margin: "dense"
  }, _react.default.createElement(_core.InputLabel, _extends({
    ref: inputLabel,
    htmlFor: name
  }, inputLabelProps), label), _react.default.createElement(_core.OutlinedInput, _extends({
    disabled: disabled,
    autoFocus: autoFocus,
    value: value ? value : "",
    labelWidth: labelWidth,
    name: name,
    id: name,
    onChange: handleChange(name),
    startAdornment: startAdornment,
    endAdornment: endAdornment,
    multiline: multiline || undefined,
    rows: rows,
    placeholder: placeholder,
    inputComponent: mask || "input"
  }, inputProps)));
};

var _default = TsTextField;
exports.default = _default;

//# sourceMappingURL=TsTextField.jsx.map